export const STORAGE_NAME = "paris-events";

// Deux adresses plutôt qu'une, pour que le courrier se trie tout seul à
// l'arrivée : ce qui concerne l'agenda d'un côté, ce qui s'adresse à son
// auteur de l'autre.
export const CONTACT_EMAIL = "contact@getoutpaname.com";
export const AUTHOR_EMAIL = "contact@sinaysenera.dev";
export const PORTFOLIO_URL = "https://sinaysenera.dev/";

// Source des événements.
export const DATA_SOURCE_URL =
  "https://opendata.paris.fr/explore/dataset/que-faire-a-paris-/information/";

// À remettre à jour en même temps que le contenu des pages légales.
export const LEGAL_UPDATED = "15 octobre 2026";
